/* eslint-disable default-case */
import { CheckCircleOutlined, CloseSquareOutlined, DownOutlined, EditOutlined, ImportOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons'
import { Checkbox, Col, Dropdown, Menu, Row, Space, Table, Tag } from 'antd'
import React, { useState, useEffect } from 'react'

import ParticipantModal from './ParticipantModal'
import ImportModel from './ImportModal'

import useWindowDimensions from '../../../../hooks/getWindowDimensions'

import './css/tournament-checkin.css'
import _ from 'lodash'
import { getPossibleRating } from '../../../../shared/tournamentRating'
import Button from 'antd-button-color'

const TournamentCheckin = (props) => {
  const columns = [
    {
      title: 'presence',
      dataIndex: 'presence',
      sorter: (a, b) => {
        if (a.presence < b.presence) return -1
        if (a.presence > b.presence) return 1
        return 0
      },
      display: true,
      required: true,
      align: 'right',
      width: '5em',
      render: (value, record) => {
        let icon = (<CloseSquareOutlined />)
        let color = 'participant-absent'
        if (value) {
          icon = (<CheckCircleOutlined />)
          color = 'participant-present'
        }
        return (<Button key={`presense-${record.uuid}`} type='primary' shape='circle' icon={icon} onClick={() => { updatePresence(value, record.uuid) }} className={color} />)
      }
    },
    {
      title: 'last name',
      dataIndex: 'last_name',
      sorter: (a, b) => {
        if (a.last_name < b.last_name) return -1
        if (a.last_name > b.last_name) return 1
        return 0
      },
      display: true
    },
    {
      title: 'first name',
      dataIndex: 'first_name',
      sorter: (a, b) => {
        if (a.first_name < b.first_name) return -1
        if (a.first_name > b.first_name) return 1
        return 0
      },
      display: true
    },
    {
      title: 'age',
      dataIndex: 'age',
      sorter: (a, b) => a.age - b.age,
      display: false
    },
    {
      title: 'demographic',
      dataIndex: 'demographic',
      sorter: (a, b) => {
        if (a.demographic < b.demographic) return -1
        if (a.demographic > b.demographic) return 1
        return 0
      },
      display: false,
      render: (value) => {
        let color = 'default'
        switch (value) {
          case 'open': {
            color = 'green'
            break
          }
          case 'ladies': {
            color = 'purple'
            break
          }
          case 'cadet': {
            color = 'blue'
          }
        }
        return (
          <Tag color={color} key={value}>
            {value?.toUpperCase()}
          </Tag>
        )
      }
    },
    {
      title: 'club',
      dataIndex: 'club',
      sorter: (a, b) => {
        if (a.club < b.club) return -1
        if (a.club > b.club) return 1
        return 0
      },
      display: true
    },
    {
      title: 'rating',
      dataIndex: 'rating',
      sorter: (a, b) => {
        if (a.rating < b.rating) return -1
        if (a.rating > b.rating) return 1
        return 0
      },
      display: true
    },
    {
      title: 'edit',
      dataIndex: 'edit',
      display: true,
      required: true,
      align: 'center',
      width: '5em',
      render: (value, record) => {
        return (
          <Button
            key={`edit-${record.uuid}`} type='info' shape='circle' icon={<EditOutlined />} onClick={() => {
              setCurrentParticipant(record)
              setShowAddParticipantModal(true)
            }}
          />
        )
      }
    }
  ]

  const { height } = useWindowDimensions()
  const [participants, setParticipants] = useState([])
  const [showAddParticipantModal, setShowAddParticipantModal] = useState(false)
  const [showImportModal, setShowImportModal] = useState(false)
  const [presentParticipants, setPresentParticipants] = useState(0)
  const [absentParticipants, setAbsentParticipants] = useState(0)
  const [selectedRows, setSelectedRows] = useState([])
  const [resultColumns, setResultColumns] = useState(columns.map(c => Object.assign({}, _.pick(c, ['required', 'dataIndex', 'display', 'title']))))
  const [isResultColumnSelectorVisible, setIsResultColumnSelectorVisible] = useState(false)
  const [currentParticipant, setCurrentParticipant] = useState()

  const [tournament, setTournament] = useState({})

  useEffect(() => {
    const newTournament = props.tournament

    // clear next step
    const nextStep = props.step + 1
    let stepName = props.tournament.schedule[nextStep]
    if (stepName === 'bestof') {
      stepName = 'table'
    }
    delete newTournament[`${stepName}_${nextStep}`]

    setTournament(props.tournament)
    setParticipants(props.tournament.participants)
    // eslint-disable-next-line
  }, [props.tournament])

  useEffect(() => {

  }, [currentParticipant])

  const saveTournamentData = () => {
    let possibleRating = 'NR'

    if (participants) {
      const present = participants.filter(p => p.presence)
      possibleRating = getPossibleRating(Object.assign({}, tournament, { participants: present }))
    }

    const tournamentData = Object.assign({}, tournament, { possibleRating })
    tournamentData.participants = participants
    props.onTournamentUpdate(tournamentData)
    props.onUpdate(tournamentData)
  }

  const addParticipant = (values) => {
    setCurrentParticipant({})
    setShowAddParticipantModal(true)
  }

  useEffect(() => {
    if (!_.isEmpty(tournament)) {
      saveTournamentData()
    }
    setAbsentParticipants(participants?.reduce((total, item) => (!(item.presence) ? total + 1 : total), 0))
    setPresentParticipants(participants?.reduce((total, item) => (item.presence ? total + 1 : total), 0))

    // eslint-disable-next-line
  }, [participants])

  const removeParticipant = async () => {
    await setParticipants(prevState => prevState.filter(p => {
      return !selectedRows.includes(p.uuid)
    }))
  }

  const saveParticipant = async (values) => {
    await setParticipants(prevState => {
      if (prevState) {
        const index = prevState.findIndex(p => p.uuid === values.uuid)

        if (index > -1) {
          prevState[index] = values
          return [...prevState]
        }
        return [...prevState, values]
      } else {
        return [values]
      }
    })
    setShowAddParticipantModal(false)
  }

  const importParticipants = (imported) => {
    let newParticipants
    if (participants) {
      newParticipants = [...new Set([...participants, ...imported])]
    } else {
      newParticipants = imported
    }

    setParticipants(Array.from(newParticipants))
  }

  const showImport = async () => {
    setShowImportModal(true)
  }

  const updatePresence = async (value, uuid) => {
    await setParticipants(prevState => {
      return prevState.map((p) => {
        if (p.uuid === uuid) {
          p.presence = !value
        }
        return p
      })
    })
  }

  const rowSelection = {
    selectedRowKeys: selectedRows,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRows(selectedRowKeys)
    }
  }

  const allPresent = () => {
    setParticipants(prevState => prevState.map(p => {
      p.presence = true
      return p
    }))
  }

  const allAbsent = () => {
    setParticipants(prevState => prevState.map(p => {
      p.presence = false
      return p
    }))
  }

  const dynamicSizing = {
    y: height - 400
  }

  const filterColumnsList = (value) => {
    setIsResultColumnSelectorVisible(!isResultColumnSelectorVisible)
  }

  const selectResultField = (e, value) => {
    const newFilters = JSON.parse(JSON.stringify(resultColumns))

    setResultColumns(newFilters.map(f => {
      if (value === f.dataIndex) {
        f.display = e.target.checked
      }

      return f
    }))
  }

  return (
    <div className={props.hidden ? 'hidden' : ''}>
      <div className='tournament-menu tournament-checkin'>
        <Row gutter={[8]}>
          <Col flex='0 1 15em'>
            <Row style={{ paddingBottom: 3 }}>
              <Col span={12}>
                Present
              </Col>
              <Col span={6}>
                {presentParticipants}
              </Col>
              <Col span={6}>
                <Button size='small' type='primary' className='solid-button' onClick={allPresent}>All</Button>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                Absent
              </Col>
              <Col span={6}>
                {absentParticipants}
              </Col>
              <Col span={6}>
                <Button size='small' type='primary' className='solid-button' onClick={allAbsent}>All</Button>
              </Col>
            </Row>
          </Col>
          <Col flex='none'>
            <Button block className='menu-btn' shape='round' onClick={addParticipant} style={{ height: '100%' }}>
              <PlusOutlined />
              Add
            </Button>
          </Col>
          <Col flex='none'>
            <Button block className='menu-btn' shape='round' onClick={removeParticipant} style={{ height: '100%' }}>
              <MinusOutlined />
              Remove
            </Button>
          </Col>
          <Col flex='none'>
            <Button block className='menu-btn' shape='round' onClick={showImport} style={{ height: '100%' }}>
              <ImportOutlined />
              Import Fencers
            </Button>
          </Col>
          <Col flex='auto' style={{ textAlign: 'right', paddingTop: '.2em' }}>
            <Dropdown
              overlay={<Menu
                items={resultColumns.filter(f => !f.required).map(c => Object.assign({ label: <Checkbox checked={c.display} onChange={(e) => selectResultField(e, c.dataIndex)}>{c.title}</Checkbox>, key: c.dataIndex }))}
                       />}
              onVisibleChange={filterColumnsList}
              visible={isResultColumnSelectorVisible}
              trigger={['click']}
            >
              <a href onClick={(e) => e.preventDefault()}>
                <Space>
                  Show/Hide columns
                  <DownOutlined />
                </Space>
              </a>
            </Dropdown>
          </Col>
        </Row>
      </div>
      <div>
        <Table
          pagination={false} scroll={dynamicSizing} size='small' rowKey={record => record.uuid} dataSource={participants} columns={columns.map((c, index) => {
            c.display = resultColumns[index].display
            return c
          }).filter(c => c.display)} rowSelection={rowSelection} className='checkin-participants'
        />
      </div>
      <ParticipantModal isAddParticipantVisible={showAddParticipantModal} setAddParticipantVisible={setShowAddParticipantModal} saveParticipant={saveParticipant} participant={currentParticipant} uuid={tournament?.uuid} />
      <ImportModel isImportVisible={showImportModal} setImportVisible={setShowImportModal} onImport={importParticipants} />
    </div>
  )
}

export default TournamentCheckin
